import { FP_URLS } from "../../../../domain/fund-performance/component/fund-performances/pojo/FP_URLS";
import { PP_URLS } from "../../../../domain/pp/component/base/dto/PpTab";
import { ORG_URLS_FULL } from "../../../../domain/organization/dto/ORG_URLS";
import { INVESTORS_URL } from '../../../../domain/investors-and-net-irr/dto/InvestorsURL';
import { CP_URLS } from '../../../../domain/company-performance/dto/CP_URLS';
import { getKpiCrossPortfolioUrl, KPI_URLS } from "../../../../domain/kpi/module/kpi-module-routing.module";
import { BUDGET_MODEL_URL } from "src/app/domain/fund-budget-model/pojo/bm-const";
import { DATA_ROOM_URLS } from "../../../../domain/box/component/data-room/data-room.util";

export const URL_PRESET = {
  [FP_URLS.BASE + '/' + FP_URLS.VALUE_CREATION]: {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  [INVESTORS_URL.BASE + '/' + INVESTORS_URL.CC_TRACKER]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  [INVESTORS_URL.BASE + '/' + INVESTORS_URL.DISTRIBUTION_TRACKER]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._overview]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: true,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._insights]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._investment]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._with_appreciation]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._soi]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._details]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._cash_on_cash]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: true,
    periodTypeSwitcher: true,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._cashflow_matrix]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: true,
    periodTypeSwitcher: true,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [FP_URLS.BASE + '/' + FP_URLS.FUND + '/' + PP_URLS.base + '/' + PP_URLS._analytics + '/' + PP_URLS._valuationBasis]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  [PP_URLS._comparison]: {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: true,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  [CP_URLS.BASE]: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: true,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: true,
    orcaAiButton: true,
  },
  portfoliocompanies: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  'portfolio-performance': { /** {@link PerformancePredictionModelComponent*/
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: true,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'kpi/metrics': {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'kpi/companies': {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'kpi/portfolio-analysis': {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  [KPI_URLS.base + '/' + KPI_URLS._bulkRequest]: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: false,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  [getKpiCrossPortfolioUrl()]: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  [DATA_ROOM_URLS.ADMIN]: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: false,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  cabinet: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: false,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'org-user-management': {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: false,
    search: false,
    notifications: false,
    logoSlider: false,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  organizations: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  [ORG_URLS_FULL.OVERVIEW]: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: true,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: true,
  },
  'market-analysis/by-vintage': {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: true,
    vintagePeriods: true,
    search: false,
    adminSwitcher: false,
    notifications: false,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'market-analysis/by-industry': {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: true,
    adminSwitcher: false,
    vintagePeriods: false,
    notifications: false,
    search: false,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'market-analysis/by-stock': {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  holding: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  recovery: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  components: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  documents: {
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: true,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  financialStatement: {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'growth-potential': {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'investor-report': {
    showOrgFundPicker: true,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'next-round-allocation': {
    showOrgFundPicker: true,
    periods: true,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    showPortfolio: false,
    singleOrg: false,
    market_analysis: false,
    vintagePeriods: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  'fund-strategy': {
    singleOrg: true,
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    market_analysis: false,
    vintagePeriods: false,
    showPortfolio: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
    orcaAiButton: false,
  },
  [BUDGET_MODEL_URL.base]: {
    singleOrg: true,
    showOrgFundPicker: false,
    periods: false,
    numberSwitcher: false,
    periodTypeSwitcher: false,
    showIrr: false,
    market_analysis: false,
    vintagePeriods: false,
    showPortfolio: false,
    adminSwitcher: true,
    search: true,
    notifications: true,
    logoSlider: true,
    allPeriodsButton: false,
  },
};

